var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7114 4.35866L9.14724 4.78335C9.33178 4.96318 9.33178 5.25397 9.14724 5.43188L5.3327 9.15085C5.14815 9.33068 4.84974 9.33068 4.66716 9.15085L0.852622 5.43379C0.66808 5.25396 0.66808 4.96318 0.852622 4.78527L1.28846 4.36057C1.47496 4.17883 1.77926 4.18266 1.96184 4.36822L4.21366 6.67154L4.21366 1.17343C4.21366 0.918991 4.42372 0.714294 4.68483 0.714294L5.31306 0.714294C5.57417 0.714294 5.78424 0.918991 5.78424 1.17343L5.78424 6.67154L8.03802 4.36631C8.2206 4.17883 8.5249 4.175 8.7114 4.35866Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendArrowDown);
export default __webpack_public_path__ + "97131/static/media/TrendArrowDown.428bcb025e0ddee30260bec41846d911.svg";
export { ForwardRef as ReactComponent };